module.exports = __webpack_public_path__ + "img/settingsGear_w.2b20028d.svg";